// helpContent.js — مولَّد آليًّا من frontend-Vit2/src/features/help/*.ts.
//
// لا تُحرّر هذا الملفّ: عدّل المصدر ثمّ شغّل `node scripts/sync_help_content.js`.
// أيّ تحرير هنا يُمحى عند أوّل مزامنة.

// helpSections.ts — أقسام: البدء · الخيل والمُلّاك · العيادة البيطريّة · مفاهيم عيادة الإنتاج.

const MODULE_SECTIONS = [
	{
		id: 'start',
		title: { ar: 'البدء — الشريط العلويّ والتنقّل', en: 'Getting started — top bar and navigation' },
		summary: { ar: 'كيف تتنقّل، وأين اللغة والتنبيهات وهذه الصفحة.', en: 'How to navigate, and where language, notifications and this page live.' },
		blocks: [
			{
				kind: 'list',
				items: [
					{ ar: 'القائمة الجانبيّة تعرض الوحدات المسموحة لك. زرّ الطيّ في الشريط العلويّ يوسّع مساحة العمل.', en: 'The sidebar shows the modules you may use. The collapse button in the top bar widens the working area.' },
					{ ar: 'الجرس = التنبيهات: مهامّ مستحقّة، نواقص مخزون، متابعات عيادة الإنتاج.', en: 'The bell = notifications: due tasks, low stock, reproduction follow-ups.' },
					{ ar: 'زرّ اللغة يبدّل بين العربيّة والإنجليزيّة فورًا، بما في ذلك هذه الصفحة.', en: 'The language button switches between Arabic and English instantly, including this page.' },
					{ ar: 'علامة (؟) في الشريط العلويّ تفتح هذه الصفحة من أيّ مكان في النظام.', en: 'The (?) mark in the top bar opens this page from anywhere in the system.' },
					{ ar: 'قائمة المستخدم فيها ملفّك الشخصيّ وتغيير كلمة المرور وتسجيل الخروج.', en: 'The user menu holds your profile, password change and sign-out.' },
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'إن ظهرت لك صفحة «لا صلاحية»، فالمسار صحيح لكنّه غير ممنوح لحسابك. لا تُعِد المحاولة — اطلب الصلاحية من مدير النظام (مركز الصلاحيات والقائمة).',
					en: 'If you land on the “no access” page, the route is correct but not granted to your account. Do not retry — request the permission from your administrator (Access control).',
				},
			},
		],
	},

	{
		id: 'horses',
		title: { ar: 'الخيل والمُلّاك — الأساس', en: 'Horses & owners — the foundation' },
		summary: { ar: 'السجلّ الذي تقوم عليه كلّ الوحدات، وقواعده التي تفسّر سلوك بقيّة النظام.', en: 'The registry everything rests on, and the rules that explain the rest of the system.' },
		blocks: [
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — تسجيل خيل', en: '1 — Register a horse' },
						detail: { ar: 'من «تسجيل خيل»: الاسم بالعربيّة والإنجليزيّة، الجنس، تاريخ الميلاد، اللون، السلالة، المالك، ورقم الشريحة إن وُجد.', en: 'From “Register horse”: name in Arabic and English, sex, date of birth, colour, breed, owner, and chip number if any.' },
						auto: { ar: 'رقم الشريحة اختياريّ — خيل بلا شريحة تُسجَّل وتُعالَج طبيعيًّا.', en: 'The chip number is optional — a horse without one registers and is treated normally.' },
					},
					{
						title: { ar: '٢ — متابعة الخيل', en: '2 — Follow a horse' },
						detail: { ar: '«تفاصيل الخيل» تجمع بطاقته، و«تاريخ الخيل» يعرض كلّ ما جرى له عبر الوحدات: عيادة، بيطار، إنتاج، تسكين، بطولات.', en: 'Horse details gathers its card; horse history shows everything that happened to it across modules: clinic, farrier, reproduction, housing, competitions.' },
					},
					{
						title: { ar: '٣ — النسب', en: '3 — Pedigree' },
						detail: { ar: '«شجرة النسب» تعرض السلالة. والمواليد المسجَّلة من عيادة الإنتاج تدخل هنا بنسب مرتبط بالسجلّات لا مكتوب باليد.', en: 'The pedigree tree shows lineage. Foals registered from the reproduction clinic enter with a linked pedigree, not typed text.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'المالك يُلتقط لحظة تنفيذ العمليّة لا لحظة عرض التقرير. فنقل ملكيّة خيل لاحقًا لا يُغيّر فواتير الماضي ولا ينسبها للمالك الجديد — وهذا مقصود.',
					en: 'The owner is captured at the moment of the operation, not when a report is viewed. Transferring a horse later does not rewrite past invoices onto the new owner — this is deliberate.',
				},
			},
		],
	},

	{
		id: 'vet',
		title: { ar: 'العيادة البيطريّة — تفصيل', en: 'Veterinary clinic — in detail' },
		summary: { ar: 'حالات الاستخدام، ودورة سجلّ العيادة من الكشف إلى الفاتورة.', en: 'Use cases, and the clinic record cycle from examination to invoice.' },
		blocks: [
			{ kind: 'sub', text: { ar: 'متى تستخدم العيادة البيطريّة', en: 'When to use the veterinary clinic' } },
			{
				kind: 'list',
				items: [
					{ ar: 'كشف أو علاج لخيل: إصابة، عرَض مرضيّ، متابعة حالة.', en: 'An examination or treatment: injury, symptom, follow-up of a condition.' },
					{ ar: 'صرف دواء بجرعة محسوبة ومدّة محدّدة، مع خصمه من المخزون.', en: 'Dispensing a medication with a computed dose and defined duration, deducted from stock.' },
					{ ar: 'إجراء له سعر في الكتالوج (سونار، تطعيم، خياطة…) ويجب أن يصل إلى المحاسبة.', en: 'A priced catalogue procedure (ultrasound, vaccination, suturing…) that must reach accounting.' },
					{ ar: 'فحص دوريّ مجدول لمجموعة خيل — عبر «أنواع الفحوصات» و«الفحوصات البيطرية».', en: 'A scheduled routine checkup for a group of horses — via checkup types and the checkups screen.' },
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'ما يخصّ التلقيح والحمل والولادة لا يُسجَّل هنا بل في عيادة الإنتاج. العيادتان منفصلتان في القائمة وفي الإعدادات لهذا السبب: لكلٍّ كتالوج إجراءات وأسعار وسجلّات مستقلّة.',
					en: 'Anything about breeding, pregnancy or foaling is not recorded here but in the reproduction clinic. The two clinics are separated in the menu and the settings for that reason: each has its own procedure catalogue, prices and records.',
				},
			},
			{ kind: 'sub', text: { ar: 'دورة سجلّ العيادة', en: 'The clinic record cycle' } },
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'اختيار الخيل', en: 'Pick the horse' }, sub: { ar: 'بالاسم أو الشريحة', en: 'by name or chip' } },
					{ label: { ar: 'الإجراءات', en: 'Procedures' }, sub: { ar: 'من الكتالوج بسعرها', en: 'priced catalogue' } },
					{ label: { ar: 'الأدوية', en: 'Medications' }, sub: { ar: 'تكرار × مدّة', en: 'frequency × duration' } },
					{ label: { ar: 'حفظ', en: 'Save' }, sub: { ar: 'خصم من المخزون', en: 'stock deducted' } },
					{ label: { ar: 'اعتماد', en: 'Approve' }, sub: { ar: 'اعتمادات العيادة', en: 'clinic approvals' } },
					{ label: { ar: 'المحاسبة', en: 'Accounting' }, sub: { ar: 'رسم على المالك', en: 'charge to the owner' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح نموذج سجلّ العيادة', en: '1 — Open the clinic record form' },
						detail: { ar: 'من «نموذج سجل العيادة». اختر الخيل بالاسم أو بقراءة رقم الشريحة. تظهر بطاقة الخيل ومالكه للتأكّد قبل المتابعة.', en: 'From the clinic form. Pick the horse by name or by reading its chip. The horse card and its owner appear so you can confirm before continuing.' },
					},
					{
						title: { ar: '٢ — التاريخ والطبيب والملاحظات', en: '2 — Date, veterinarian and notes' },
						detail: { ar: 'التاريخ والوقت يأتيان باللحظة الحاليّة ويمكن تعديلهما. اكتب التشخيص والملاحظات — هي ما سيقرأه من يفتح السجلّ بعد شهور.', en: 'Date and time default to now and can be changed. Write the diagnosis and notes — they are what someone reading the record months later will rely on.' },
					},
					{
						title: { ar: '٣ — أضف الإجراءات', en: '3 — Add procedures' },
						detail: { ar: 'الإجراءات تأتي من كتالوج «إجراءات العيادة» بسعرها المعرَّف. لا تُكتب يدويًّا — فالاسم والسعر مرجعهما الكتالوج.', en: 'Procedures come from the clinic procedures catalogue at their defined price. They are not typed by hand — name and price both come from the catalogue.' },
					},
					{
						title: { ar: '٤ — أضف الأدوية بجرعاتها', en: '4 — Add medications with dosing' },
						detail: { ar: 'اختر الدواء، ثمّ التكرار اليوميّ (مرّة، مرّتان، ثلاث…) وعدد الأيّام. النظام يحسب إجماليّ الوحدات ويعرض جدول الجرعات نصًّا واضحًا.', en: 'Pick the medication, then the daily frequency (once, twice, three times…) and the number of days. The system computes total units and shows the schedule in plain text.' },
						auto: { ar: 'الإجماليّ المحسوب يُخصم من مخزون الدواء عند الحفظ.', en: 'The computed total is deducted from medication stock on save.' },
					},
					{
						title: { ar: '٥ — احفظ', en: '5 — Save' },
						detail: { ar: 'السجلّ يظهر في «سجلات العيادة»، ويُفتح من «تفاصيل سجل العيادة» أو يُعدَّل من «تعديل سجل بيطري».', en: 'The record appears in the records list, opens from record details, and is changed from the edit screen.' },
					},
					{
						title: { ar: '٦ — الاعتماد', en: '6 — Approval' },
						detail: { ar: 'من «اعتمادات العيادة» يُراجَع السجلّ ويُعتمد. الاعتماد بوّابة مقصودة: هو ما يفصل مسوّدة الطبيب عن رقم يُحاسَب عليه المالك.', en: 'From clinic approvals the record is reviewed and approved. Approval is a deliberate gate: it separates the vet’s draft from a figure the owner is billed for.' },
					},
					{
						title: { ar: '٧ — المحاسبة', en: '7 — Accounting' },
						detail: { ar: 'الرسوم تظهر في «مراجعة المحاسب» و«دفتر خدمات الخيل» و«الملخص المالي» حسب المالك والفترة.', en: 'Charges appear in accountant review, the horse services ledger and the financial summary, by owner and period.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'خيل يملكه الإسطبل نفسه لا يُفوتَر: النظام يقارن مالك الخيل بمالك الإسطبل المعرَّف في «الإعدادات العامة»، فإن تطابقا لم يُنشأ رسم. الخدمة تُسجَّل كاملة، لكنّ الإسطبل لا يُفوتر نفسه.',
					en: 'A horse owned by the stable itself is not billed: the system compares the horse’s owner with the stable owner defined in system settings, and if they match no charge is created. The service is still fully recorded — the stable simply does not invoice itself.',
				},
			},
			{ kind: 'sub', text: { ar: 'البيانات المرجعيّة التي تُغذّي العيادة', en: 'Reference data that feeds the clinic' } },
			{
				kind: 'table',
				head: [
					{ ar: 'ماذا', en: 'What' },
					{ ar: 'أين تُدار', en: 'Where it is managed' },
					{ ar: 'أثرها', en: 'Effect' },
				],
				rows: [
					[
						{ ar: 'إجراءات العيادة وأسعارها', en: 'Clinic procedures and prices' },
						{ ar: '«إجراءات العيادة» — إضافة وتعديل', en: 'Clinic procedures — add & edit' },
						{ ar: 'تحدّد ما يمكن اختياره في السجلّ وبكم يُحتسب', en: 'Determine what can be selected in a record and at what price' },
					],
					[
						{ ar: 'الأدوية ومخزونها', en: 'Medications and stock' },
						{ ar: '«أدوية العيادة» و«المخزون»', en: 'Medications and Inventory' },
						{ ar: 'الرصيد يُخصم عند الصرف، ونقصه يولّد تنبيهًا', en: 'Balance is deducted on dispensing; shortages raise a notification' },
					],
					[
						{ ar: 'أنواع الفحوصات الدوريّة', en: 'Routine checkup types' },
						{ ar: '«أنواع الفحوصات»', en: 'Checkup types' },
						{ ar: 'تُبنى عليها «الفحوصات البيطرية» وتقريرها', en: 'The checkups screen and its report are built on them' },
					],
				],
			},
		],
	},
];

// helpScenarios.ts — عيادة الإنتاج: المفاهيم والمواعيد، ثمّ سيناريوهات التلقيح والحمل
// كاملةً، ثمّ الولادة والنسب. القيَم الزمنيّة كلّها مقروءة من
// `backend-node22/utils/reproductionDateCalculator.js` وهي إعدادات قابلة للتعديل.

const SCENARIO_SECTIONS = [
	{
		id: 'repro-basics',
		title: { ar: 'عيادة الإنتاج — المفاهيم والمواعيد', en: 'Reproduction clinic — concepts and timing' },
		summary: { ar: 'ما «الحالة»، وأنواعها، وحالاتها، والمواعيد التي يحسبها النظام وحده.', en: 'What a case is, its types and statuses, and the dates the system computes on its own.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'الحالة (Case) هي ملفّ موسم واحد لفرس واحدة بغرض واحد. كلّ ما يجري بعدها — فحص بالسونار، تحفيز إباضة، تلقيح، فحص حمل، غسل أجنّة، نقل، ولادة — يُسجَّل داخلها لا مستقلًّا عنها. ولهذا: افتح الحالة أوّلًا، ثمّ سجّل الأحداث فيها.',
					en: 'A case is one season file for one mare with one purpose. Everything that follows — ultrasound examination, ovulation trigger, insemination, pregnancy check, embryo flush, transfer, foaling — is recorded inside it, not separately. So: open the case first, then record events in it.',
				},
			},
			{
				kind: 'list',
				items: [
					{ ar: 'نوع الحالة يحدّد المسار الذي ستسلكه، ويحدّد أيضًا الحالات المعروضة عليك.', en: 'The case type determines the path it will follow, and also which statuses are offered to you.' },
					{ ar: 'حالة الحالة تتحرّك آليًّا مع الأحداث: تسجّل تلقيحًا فتصير «ملقحة»، تؤكّد حملًا فتصير «حامل». نادرًا ما تحتاج تغييرها يدويًّا.', en: 'The status moves automatically with events: record an insemination and it becomes Inseminated; confirm a pregnancy and it becomes Pregnant. You rarely need to change it by hand.' },
					{ ar: 'المهامّ وأحداث التقويم والتنبيهات تُنشأ آليًّا عند كلّ حدث — فالموعد التالي لا يعتمد على أن يتذكّره أحد.', en: 'Tasks, calendar events and notifications are created automatically at each event — the next appointment does not depend on anyone remembering it.' },
					{ ar: 'التقويم يعرض الموسم كلّه، وتبويب المهامّ نافذة عمل: ما يستحقّ خلال ٤٨ ساعة وما فات موعده. ومن كلّ مهمّة إمّا أن تُنجزها وتكتب النتيجة، أو تُلغيها وتذكر السبب — والإلغاء لا يمرّ بلا سبب.', en: 'The calendar shows the whole season; the tasks tab is a working window: what is due within 48 hours and anything overdue. From each task you either complete it and record the result, or cancel it and state why — a cancellation does not pass without a reason.' },
					{ ar: 'الرسوم تُنشأ آليًّا لكلّ إجراء له سعر في «إجراءات الإنتاج»، بنفس قاعدة العيادة: لا فاتورة على خيل يملكه الإسطبل.', en: 'Charges are created automatically for every procedure priced in the reproduction catalogue, under the same rule: no invoice for a horse the stable owns.' },
				],
			},
			{ kind: 'sub', text: { ar: 'أنواع الحالات — أيّها تختار', en: 'Case types — which to choose' } },
			{
				kind: 'table',
				head: [
					{ ar: 'النوع', en: 'Type' },
					{ ar: 'متى تختاره', en: 'When to choose it' },
				],
				rows: [
					[{ ar: 'تلقيح اصطناعي', en: 'Artificial insemination' }, { ar: 'تلقيح الفرس بسائل طازج أو مبرَّد.', en: 'Inseminating the mare with fresh or chilled semen.' }],
					[{ ar: 'تلقيح بسائل مجمد', en: 'Frozen semen insemination' }, { ar: 'سائل مجمّد — نافذته الزمنيّة أضيق والمتابعة قرب الإباضة أكثف.', en: 'Frozen semen — a narrower timing window and closer monitoring near ovulation.' }],
					[{ ar: 'تلقيح طبيعي', en: 'Natural cover' }, { ar: 'قفزة مباشرة من الفحل.', en: 'Direct cover by the stallion.' }],
					[{ ar: 'مانحة أجنة', en: 'Embryo transfer donor' }, { ar: 'فرس تُلقَّح ثمّ يُغسل جنينها لينتقل إلى حاضنة. هي أمّ المولود نَسَبيًّا.', en: 'A mare inseminated, then flushed so the embryo moves to a recipient. She is the foal’s dam by pedigree.' }],
					[{ ar: 'مستقبلة أجنة (حاضنة)', en: 'Embryo transfer recipient' }, { ar: 'فرس تحمل جنين غيرها وتلده. تحمل الحمل والولادة، ولا تُنسب إليها الأمومة.', en: 'A mare who carries and delivers another mare’s embryo. She carries the pregnancy and the birth, but is not the dam.' }],
					[{ ar: 'متابعة حمل', en: 'Pregnancy follow-up' }, { ar: 'فرس وصلت حاملًا ولم يُلقّحها المركز — تُتابَع حتى الولادة.', en: 'A mare that arrived already pregnant, not bred here — followed through to foaling.' }],
				],
			},
			{ kind: 'sub', text: { ar: 'حالات الحالة ومعناها', en: 'Statuses and what they mean' } },
			{
				kind: 'table',
				head: [
					{ ar: 'الحالة', en: 'Status' },
					{ ar: 'معناها', en: 'Meaning' },
					{ ar: 'تظهر لأنواع', en: 'Offered for' },
				],
				rows: [
					[{ ar: 'مفتوحة', en: 'Open' }, { ar: 'حالة أُنشئت ولم يبدأ فيها حدث بعد.', en: 'A case created with no event yet.' }, { ar: 'الكلّ', en: 'All' }],
					[{ ar: 'بانتظار الإباضة', en: 'Waiting ovulation' }, { ar: 'الفرس تحت المتابعة بالسونار حتى تنضج الحويصلة.', en: 'The mare is under ultrasound monitoring until the follicle matures.' }, { ar: 'الكلّ عدا متابعة الحمل', en: 'All but follow-up' }],
					[{ ar: 'تمّت الإباضة', en: 'Ovulated' }, { ar: 'الإباضة مؤكَّدة ولا تلقيح مسجَّل بعد.', en: 'Ovulation confirmed with no insemination recorded yet.' }, { ar: 'الكلّ عدا متابعة الحمل', en: 'All but follow-up' }],
					[{ ar: 'ملقحة', en: 'Inseminated' }, { ar: 'تلقيح مسجَّل فعلًا بجرعة من المخزون.', en: 'An insemination actually recorded against a stock dose.' }, { ar: 'التلقيح بأنواعه + المانحة', en: 'Insemination types + donor' }],
					[{ ar: 'تم غسل الأجنة', en: 'Flushed' }, { ar: 'جنين المانحة غُسل. وتبقى هذه حالتها بعد النقل.', en: 'The donor’s embryo was flushed. This remains her status after the transfer.' }, { ar: 'المانحة فقط', en: 'Donor only' }],
					[{ ar: 'تم النقل', en: 'Transferred' }, { ar: 'جنين نُقل إلى هذه الحاضنة.', en: 'An embryo was transferred into this recipient.' }, { ar: 'المستقبلة فقط', en: 'Recipient only' }],
					[{ ar: 'حامل', en: 'Pregnant' }, { ar: 'الحمل مؤكَّد بفحص.', en: 'Pregnancy confirmed by a check.' }, { ar: 'التلقيح + المستقبلة + المتابعة', en: 'Insemination + recipient + follow-up' }],
					[{ ar: 'غير حامل', en: 'Not pregnant' }, { ar: 'الفحص لم يؤكّد حملًا.', en: 'The check did not confirm a pregnancy.' }, { ar: 'التلقيح + المستقبلة + المتابعة', en: 'Insemination + recipient + follow-up' }],
					[{ ar: 'مغلقة', en: 'Closed' }, { ar: 'الموسم انتهى بنتيجته.', en: 'The season ended with its outcome.' }, { ar: 'الكلّ', en: 'All' }],
					[{ ar: 'ملغاة', en: 'Cancelled' }, { ar: 'الحالة أُوقفت ولم تُستكمل.', en: 'The case was stopped and not completed.' }, { ar: 'الكلّ', en: 'All' }],
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'القائمة تُصفّى حسب نوع الحالة، فلن ترى «تم غسل الأجنة» على حاضنة ولا «حامل» على مانحة. أمّا الحالات التي تضيفها أنت من الإعدادات فتظهر لكلّ الأنواع — النظام لا يحجب ما لا يعرف سياقه.',
					en: 'The list is filtered by case type, so you will not see Flushed on a recipient or Pregnant on a donor. Statuses you add yourself in settings appear for every type — the system never hides what it does not understand.',
				},
			},
			{ kind: 'sub', text: { ar: 'المواعيد التي يحسبها النظام', en: 'Dates the system computes' } },
			{
				kind: 'table',
				head: [
					{ ar: 'الموعد', en: 'Date' },
					{ ar: 'القاعدة الافتراضيّة', en: 'Default rule' },
				],
				rows: [
					[{ ar: 'نافذة تأكيد الإباضة', en: 'Ovulation confirmation window' }, { ar: 'من ٣٦ إلى ٤٨ ساعة بعد التحفيز', en: '36 to 48 hours after the trigger' }],
					[{ ar: 'أوّل فحص حمل', en: 'First pregnancy check' }, { ar: 'بعد ١٤ يومًا من الإباضة', en: '14 days after ovulation' }],
					[{ ar: 'متابعة فحص الحمل', en: 'Pregnancy re-check' }, { ar: 'بعد ٤٠ يومًا', en: 'after 40 days' }],
					[{ ar: 'الولادة المتوقّعة', en: 'Expected foaling' }, { ar: 'بعد ٣٤٠ يومًا من الإباضة', en: '340 days after ovulation' }],
					[{ ar: 'نافذة غسل الأجنّة', en: 'Embryo flush window' }, { ar: 'اليوم ٧–٨ بعد الإباضة (٦٫٥ استثناءً بتحذير)', en: 'day 7–8 after ovulation (6.5 as a flagged exception)' }],
					[{ ar: 'تزامن الحاضنة مع المانحة', en: 'Recipient synchronisation' }, { ar: 'المثالي: فارق ٠ إلى +٢ يوم · المقبول: −١ إلى +٣', en: 'Ideal: 0 to +2 days · acceptable: −1 to +3' }],
					[{ ar: 'الفحص التالي حسب حجم الحويصلة', en: 'Next exam by follicle size' }, { ar: '٣٢مم فأكثر ⇐ غدًا · ٢٨مم ⇐ بعد يومين · ٢٠مم ⇐ بعد ٣ أيّام · أقلّ ⇐ بعد ٥ أيّام', en: '32 mm+ ⇒ tomorrow · 28 mm ⇒ 2 days · 20 mm ⇒ 3 days · below ⇒ 5 days' }],
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'هذه القيَم إعدادات لا برمجة: تُعدَّل من «معايير البروتوكول» في صفحة عيادة الإنتاج، ويسري التعديل على ما يُحسب بعده.',
					en: 'These values are settings, not code: change them in the protocol parameters on the reproduction page, and the change applies to everything computed afterwards.',
				},
			},
		],
	},

	{
		id: 'screen-map',
		title: { ar: 'خريطة شاشات عيادة الإنتاج', en: 'Map of the reproduction clinic screens' },
		summary: { ar: 'أين تفعل ماذا — قبل أيّ سيناريو.', en: 'Where you do what — before any scenario.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'كلّ شيء يبدأ من «عيادة الإنتاج» في القائمة الجانبيّة. وأعلى الصفحة شريط مداخل إلى الصفحات المتخصّصة الخمس — فلا تبحث عنها في الإعدادات، لم تعد هناك.',
					en: 'Everything starts from Reproduction clinic in the sidebar. At the top of the page sits a row of entries to the five specialised screens — do not look for them in Settings; they are no longer there.',
				},
			},
			{
				kind: 'table',
				head: [
					{ ar: 'الشاشة', en: 'Screen' },
					{ ar: 'ما تفعله فيها', en: 'What you do there' },
				],
				rows: [
					[{ ar: 'تبويب «لوحة التشغيل»', en: 'Dashboard tab' }, { ar: 'ما عندك اليوم: جدول بمفتاح أسبوع/شهر، وآخر المتابعات، وتغييرات البروتوكول، والتنبيهات الحَرِجة.', en: 'What you have on: a schedule with a week/month switch, recent follow-ups, protocol changes, and critical alerts.' }],
					[{ ar: 'تبويب «الحالات»', en: 'Cases tab' }, { ar: 'شاشة العمل: قائمة الحالات يمينًا، وتفصيل الحالة المختارة وخطّها الزمنيّ يسارًا، ومنها «إضافة إجراء».', en: 'The working screen: the case list on one side, the selected case with its timeline on the other, and Add Action.' }],
					[{ ar: 'تبويب «المهامّ»', en: 'Tasks tab' }, { ar: 'ما يستحقّ خلال ٤٨ ساعة وما فات موعده — تُنجزه أو تُلغيه بسبب.', en: 'Due within 48 hours and anything overdue — complete it or cancel it with a reason.' }],
					[{ ar: 'تبويب «متابعة الموسم»', en: 'Season tab' }, { ar: 'جدولان عريضان (الأجنّة والحمل) لقراءة الموسم كلّه دفعةً واحدة.', en: 'Two wide tables (embryos and pregnancies) to read the whole season at once.' }],
					[{ ar: 'تبويب «البروتوكول»', en: 'Protocol tab' }, { ar: 'المعايير الزمنيّة: نافذة الإباضة، فحص الحمل، الولادة، الغسل، التزامن.', en: 'The timing parameters: ovulation window, pregnancy check, foaling, flush, synchronisation.' }],
					[{ ar: '«الأفراس الحاضنة»', en: 'Recipient mares' }, { ar: 'سجلّ الحاضنات: إضافة، إخراج من الخدمة، إعادة.', en: 'The recipient registry: add, retire, restore.' }],
					[{ ar: '«نقل الأجنّة»', en: 'Embryo transfer' }, { ar: 'الغسل ← الربط بحاضنة ← النقل.', en: 'Flush → pairing → transfer.' }],
					[{ ar: '«الولادات والمواليد»', en: 'Foalings and foals' }, { ar: 'تسجيل واقعة الولادة، ثمّ المواليد، ثمّ سلسلة النسب وترقية المولود إلى سجلّ خيل.', en: 'Record the foaling, then the foals, then the pedigree chain and promoting a foal to a horse record.' }],
					[{ ar: '«مخزون السائل المنويّ»', en: 'Semen inventory' }, { ar: 'الدفعات والجرعات — يُخصم منها عند تسجيل التلقيح.', en: 'Batches and doses — deducted when an insemination is recorded.' }],
					[{ ar: '«بيانات الفحل»', en: 'Stallions' }, { ar: 'سجلّ الأفحل، بما فيها فحل من خارج المركز.', en: 'The stallion registry, including outside stallions.' }],
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'داخل بطاقة الحالة يظهر **زرّ الخطوة التالية** بحسب موضعها: مانحة ملقّحة ⇐ «غسل الأجنّة»، مانحة مغسولة ⇐ «نقل الجنين إلى حاضنة»، حالة حامل ⇐ «تسجيل الولادة». يفتح الصفحة الصحيحة مباشرةً، فلا تبحث.',
					en: 'Inside the case card a **next-step button** appears according to where the case stands: an inseminated donor ⇒ “Flush embryos”, a flushed donor ⇒ “Transfer to a recipient”, a pregnant case ⇒ “Record the foaling”. It opens the right screen directly.',
				},
			},
		],
	},

	{
		id: 'scenario-ai',
		title: { ar: 'سيناريو ١ — تلقيح اصطناعيّ (سائل طازج أو مبرَّد)', en: 'Scenario 1 — Artificial insemination (fresh or chilled)' },
		summary: { ar: 'المسار الأكثر شيوعًا: من فتح الحالة إلى تأكيد الحمل.', en: 'The most common path: from opening the case to confirming the pregnancy.' },
		blocks: [
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'افتح الحالة', en: 'Open the case' }, sub: { ar: 'مفتوحة', en: 'Open' } },
					{ label: { ar: 'متابعة بالسونار', en: 'Ultrasound monitoring' }, sub: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' } },
					{ label: { ar: 'تحفيز الإباضة', en: 'Ovulation trigger' }, sub: { ar: 'نافذة ٣٦–٤٨ ساعة', en: '36–48 h window' } },
					{ label: { ar: 'التلقيح', en: 'Insemination' }, sub: { ar: 'ملقحة', en: 'Inseminated' } },
					{ label: { ar: 'تأكيد الإباضة', en: 'Confirm ovulation' }, sub: { ar: 'تُحسب مواعيد الحمل', en: 'dates computed' } },
					{ label: { ar: 'فحص الحمل', en: 'Pregnancy check' }, sub: { ar: 'حامل / غير حامل', en: 'Pregnant / not' } },
					{ label: { ar: 'المتابعة والولادة', en: 'Follow-up & foaling' }, sub: { ar: 'بعد ٣٤٠ يومًا', en: 'after 340 days' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح حالة للفرس', en: '1 — Open a case for the mare' },
						detail: { ar: 'صفحة «عيادة الإنتاج» ← زرّ «حالة جديدة». اختر الفرس، والنوع «تلقيح اصطناعي»، وتاريخ بداية الدورة.', en: 'Reproduction page → “New case”. Pick the mare, choose type “Artificial insemination”, and set the cycle start date.' },
						status: { ar: 'مفتوحة', en: 'Open' },
					},
					{
						title: { ar: '٢ — تابع الحويصلة بالسونار', en: '2 — Monitor the follicle by ultrasound' },
						detail: { ar: 'من الحالة: أضف فحصًا من نوع «سونار» وسجّل حجم الحويصلة بالمليمتر وحالة الرحم.', en: 'From inside the case: add an “Ultrasound” examination and record the follicle size in millimetres and the uterine state.' },
						auto: { ar: 'يحدّد النظام موعد الفحص التالي من حجم الحويصلة (٣٢مم ⇐ غدًا … أقلّ من ٢٠مم ⇐ بعد ٥ أيّام) ويُنشئ له مهمّة وحدثًا في التقويم.', en: 'The system sets the next exam date from the follicle size (32 mm ⇒ tomorrow … under 20 mm ⇒ 5 days) and creates a task and a calendar event for it.' },
						status: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' },
					},
					{
						title: { ar: '٣ — حفّز الإباضة', en: '3 — Trigger ovulation' },
						detail: { ar: 'حين تنضج الحويصلة: سجّل «تحفيز الإباضة» بتاريخه ووقته.', en: 'When the follicle is mature: record the ovulation trigger with its date and time.' },
						auto: { ar: 'يحسب النظام نافذة تأكيد الإباضة: من ٣٦ إلى ٤٨ ساعة بعد التحفيز، ويضعها مهمّةً في التقويم.', en: 'The system computes the confirmation window: 36 to 48 hours after the trigger, and schedules it as a task.' },
					},
					{
						title: { ar: '٤ — سجّل التلقيح', en: '4 — Record the insemination' },
						detail: { ar: 'اختر الفحل ودفعة السائل المنويّ من المخزون وعدد الجرعات. الدفعة إلزاميّة — فلكلّ تلقيح مصدر موثَّق.', en: 'Choose the stallion, the semen batch from inventory, and the number of doses. The batch is mandatory — every insemination has a documented source.' },
						auto: { ar: 'تُخصم الجرعة من الدفعة في نفس اللحظة. فإن لم يكفِ الرصيد، لا يُسجَّل التلقيح أصلًا — لا يُسجَّل تلقيح بلا سائل.', en: 'The dose is deducted from the batch at the same moment. If stock is insufficient, the insemination is not recorded at all — no insemination without semen.' },
						status: { ar: 'ملقحة', en: 'Inseminated' },
					},
					{
						title: { ar: '٥ — أكّد الإباضة', en: '5 — Confirm ovulation' },
						detail: { ar: 'داخل النافذة، سجّل «تأكيد الإباضة» بتاريخه ووقته الفعليّين. هذا التاريخ هو المرجع لكلّ ما بعده.', en: 'Inside the window, record the ovulation confirmation with its actual date and time. That date is the reference for everything after it.' },
						auto: { ar: 'يُحسب أوّل فحص حمل (+١٤ يومًا) وتاريخ الولادة المتوقّع (+٣٤٠ يومًا) وتُنشأ لهما مهمّة وحدث تقويم.', en: 'The first pregnancy check (+14 days) and the expected foaling date (+340 days) are computed, with a task and calendar event for each.' },
						status: { ar: 'تبقى «ملقحة» لأنّ التلقيح مسجَّل', en: 'stays Inseminated because an insemination exists' },
					},
					{
						title: { ar: '٦ — افحص الحمل', en: '6 — Check the pregnancy' },
						detail: { ar: 'في الموعد المستحقّ سجّل «فحص حمل» ونتيجته. الفحص التوأميّ يُسجَّل هنا أيضًا.', en: 'On the due date record a pregnancy check and its result. A twin finding is recorded here too.' },
						auto: { ar: 'النتيجة الإيجابيّة تنقل الحالة إلى «حامل» وتفتح متابعةً بعد ٤٠ يومًا. والحمل التوأميّ يولّد تنبيهًا حَرِجًا.', en: 'A positive result moves the case to Pregnant and opens a re-check after 40 days. A twin pregnancy raises a critical notification.' },
						status: { ar: 'حامل أو غير حامل', en: 'Pregnant or Not pregnant' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'إن كانت النتيجة «غير حامل»: أغلق الحالة بنتيجتها وافتح حالة جديدة للدورة التالية. لا تُعِد استخدام الحالة القديمة — كلّ حالة موسم واحد، وخلطهما يُفقد التاريخ معناه.',
					en: 'If the result is “not pregnant”: close the case with that outcome and open a new case for the next cycle. Do not reuse the old case — one case is one season, and mixing them empties the history of meaning.',
				},
			},
		],
	},

	{
		id: 'scenario-frozen',
		title: { ar: 'سيناريو ٢ — تلقيح بسائل مجمَّد', en: 'Scenario 2 — Frozen semen insemination' },
		summary: { ar: 'مسار كامل قائم بذاته، يختلف عن الطازج في نقطة واحدة حاسمة: التوقيت.', en: 'A complete standalone path; it differs from fresh semen in one decisive point: timing.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'عمر السائل المجمَّد بعد الإذابة قصير، فالتلقيح يُوضع قريبًا جدًّا من الإباضة — وهذا يستدعي متابعة أكثف في الساعات الأخيرة وتحضيرًا مسبقًا للمخزون.',
					en: 'Thawed frozen semen has a short life, so the insemination is placed very close to ovulation — which calls for tighter monitoring in the final hours and preparing the stock in advance.',
				},
			},
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'افتح الحالة', en: 'Open the case' }, sub: { ar: 'مفتوحة', en: 'Open' } },
					{ label: { ar: 'راجع المخزون', en: 'Check stock' }, sub: { ar: 'دفعة Frozen', en: 'a Frozen batch' } },
					{ label: { ar: 'متابعة مكثّفة', en: 'Close monitoring' }, sub: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' } },
					{ label: { ar: 'تحفيز الإباضة', en: 'Ovulation trigger' }, sub: { ar: 'نافذة ٣٦–٤٨ ساعة', en: '36–48 h window' } },
					{ label: { ar: 'التلقيح', en: 'Insemination' }, sub: { ar: 'ملقحة', en: 'Inseminated' } },
					{ label: { ar: 'تأكيد الإباضة', en: 'Confirm ovulation' }, sub: { ar: 'تُحسب مواعيد الحمل', en: 'dates computed' } },
					{ label: { ar: 'فحص الحمل', en: 'Pregnancy check' }, sub: { ar: 'حامل / غير حامل', en: 'Pregnant / not' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح حالة بنوع «تلقيح بسائل مجمد»', en: '1 — Open a case as “Frozen semen insemination”' },
						detail: { ar: 'صفحة «عيادة الإنتاج» ← «حالة جديدة». اختر الفرس، والنوع «تلقيح بسائل مجمد» — لا «تلقيح اصطناعي»، فالنوع هو ما يميّز الحالتين في التقارير لاحقًا — ثمّ تاريخ بداية الدورة.', en: 'Reproduction page → “New case”. Pick the mare and the type “Frozen semen insemination” — not “Artificial insemination”, since the type is what separates the two in later reports — then the cycle start date.' },
						status: { ar: 'مفتوحة', en: 'Open' },
					},
					{
						title: { ar: '٢ — راجع المخزون قبل أن تحتاجه', en: '2 — Check the stock before you need it' },
						detail: { ar: 'في «مخزون السائل المنوي»: تأكّد أنّ دفعة الفحل نوعها Frozen وأنّ رصيد جرعاتها يكفي. افعل هذا الآن لا يوم التلقيح.', en: 'In semen inventory: confirm the stallion’s batch is of type Frozen and that its dose balance suffices. Do this now, not on insemination day.' },
					},
					{
						title: { ar: '٣ — تابع الحويصلة بالسونار', en: '3 — Monitor the follicle by ultrasound' },
						detail: { ar: 'من داخل الحالة: أضف فحصًا من نوع «سونار» وسجّل حجم الحويصلة بالمليمتر وحالة الرحم، وكرّر حتى تقترب من النضج.', en: 'From inside the case: add an “Ultrasound” examination and record the follicle size in millimetres and the uterine state; repeat until maturity is near.' },
						auto: { ar: 'يحدّد النظام موعد الفحص التالي من حجم الحويصلة: ٣٢مم فأكثر ⇐ غدًا · ٢٨مم ⇐ بعد يومين · ٢٠مم ⇐ بعد ٣ أيّام · أقلّ ⇐ بعد ٥ أيّام — وهذا التكثيف التلقائيّ قرب النضج هو ما يحتاجه المجمَّد تحديدًا.', en: 'The system sets the next exam date from the follicle size: 32 mm+ ⇒ tomorrow · 28 mm ⇒ 2 days · 20 mm ⇒ 3 days · below ⇒ 5 days — and that automatic tightening near maturity is exactly what frozen semen needs.' },
						status: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' },
					},
					{
						title: { ar: '٤ — حفّز الإباضة', en: '4 — Trigger ovulation' },
						detail: { ar: 'حين تنضج الحويصلة سجّل «تحفيز الإباضة» بتاريخه ووقته.', en: 'When the follicle is mature, record the ovulation trigger with its date and time.' },
						auto: { ar: 'يحسب النظام نافذة تأكيد الإباضة: من ٣٦ إلى ٤٨ ساعة بعد التحفيز، ويضعها مهمّةً في التقويم.', en: 'The system computes the confirmation window: 36 to 48 hours after the trigger, and schedules it as a task.' },
					},
					{
						title: { ar: '٥ — سجّل التلقيح قرب الإباضة', en: '5 — Record the insemination close to ovulation' },
						detail: { ar: 'اختر الفحل ودفعة السائل المجمَّد وعدد الجرعات. الدفعة إلزاميّة — فلكلّ تلقيح مصدر موثَّق.', en: 'Choose the stallion, the frozen batch and the number of doses. The batch is mandatory — every insemination has a documented source.' },
						auto: { ar: 'تُخصم الجرعة من الدفعة في نفس اللحظة، وإن لم يكفِ الرصيد لم يُسجَّل التلقيح أصلًا.', en: 'The dose is deducted from the batch at that same moment, and if stock is insufficient the insemination is not recorded at all.' },
						status: { ar: 'ملقحة', en: 'Inseminated' },
					},
					{
						title: { ar: '٦ — أكّد الإباضة', en: '6 — Confirm ovulation' },
						detail: { ar: 'داخل النافذة، سجّل «تأكيد الإباضة» بتاريخه ووقته الفعليّين. هذا التاريخ هو المرجع لكلّ ما بعده.', en: 'Inside the window, record the ovulation confirmation with its actual date and time. That date is the reference for everything after it.' },
						auto: { ar: 'يُحسب أوّل فحص حمل (+١٤ يومًا) وتاريخ الولادة المتوقّع (+٣٤٠ يومًا)، وتُنشأ لهما مهمّة وحدث تقويم.', en: 'The first pregnancy check (+14 days) and the expected foaling date (+340 days) are computed, with a task and calendar event for each.' },
					},
					{
						title: { ar: '٧ — افحص الحمل', en: '7 — Check the pregnancy' },
						detail: { ar: 'في الموعد المستحقّ سجّل «فحص حمل» ونتيجته. الفحص التوأميّ يُسجَّل هنا أيضًا.', en: 'On the due date record a pregnancy check and its result. A twin finding is recorded here too.' },
						auto: { ar: 'النتيجة الإيجابيّة تنقل الحالة إلى «حامل» وتفتح متابعةً بعد ٤٠ يومًا. والحمل التوأميّ يولّد تنبيهًا حَرِجًا.', en: 'A positive result moves the case to Pregnant and opens a re-check after 40 days. A twin pregnancy raises a critical notification.' },
						status: { ar: 'حامل أو غير حامل', en: 'Pregnant or Not pregnant' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'نقص الجرعات لا يظهر إلّا لحظة تسجيل التلقيح، والنظام يمنعه بلا رصيد كافٍ. ومع المجمَّد لا مجال لتأجيل — النافذة ساعات لا أيّام. لذلك راجع المخزون في الخطوة ٢ لا في الخطوة ٥.',
					en: 'A dose shortage only surfaces the moment you record the insemination, and the system refuses one without sufficient stock. With frozen semen there is no room to postpone — the window is hours, not days. So check the stock at step 2, not at step 5.',
				},
			},
		],
	},

	{
		id: 'scenario-natural',
		title: { ar: 'سيناريو ٣ — تلقيح طبيعيّ (قفزة)', en: 'Scenario 3 — Natural cover' },
		summary: { ar: 'قفزة مباشرة من الفحل، موثَّقة في النظام كأيّ تلقيح.', en: 'Direct cover by the stallion, documented in the system like any insemination.' },
		blocks: [
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'افتح الحالة', en: 'Open the case' }, sub: { ar: 'مفتوحة', en: 'Open' } },
					{ label: { ar: 'متابعة بالسونار', en: 'Ultrasound monitoring' }, sub: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' } },
					{ label: { ar: 'تحفيز الإباضة', en: 'Ovulation trigger' }, sub: { ar: 'نافذة ٣٦–٤٨ ساعة', en: '36–48 h window' } },
					{ label: { ar: 'القفزة', en: 'The cover' }, sub: { ar: 'ملقحة', en: 'Inseminated' } },
					{ label: { ar: 'تأكيد الإباضة', en: 'Confirm ovulation' }, sub: { ar: 'تُحسب مواعيد الحمل', en: 'dates computed' } },
					{ label: { ar: 'فحص الحمل', en: 'Pregnancy check' }, sub: { ar: 'حامل / غير حامل', en: 'Pregnant / not' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح حالة بنوع «تلقيح طبيعي»', en: '1 — Open a case as “Natural cover”' },
						detail: { ar: 'صفحة «عيادة الإنتاج» ← «حالة جديدة». اختر الفرس، والنوع «تلقيح طبيعي»، وتاريخ بداية الدورة.', en: 'Reproduction page → “New case”. Pick the mare, choose the type “Natural cover”, and set the cycle start date.' },
						status: { ar: 'مفتوحة', en: 'Open' },
					},
					{
						title: { ar: '٢ — تابع الحويصلة بالسونار', en: '2 — Monitor the follicle by ultrasound' },
						detail: { ar: 'من داخل الحالة: أضف فحصًا من نوع «سونار» وسجّل حجم الحويصلة بالمليمتر وحالة الرحم.', en: 'From inside the case: add an “Ultrasound” examination and record the follicle size in millimetres and the uterine state.' },
						auto: { ar: 'يحدّد النظام موعد الفحص التالي من حجم الحويصلة (٣٢مم ⇐ غدًا … أقلّ من ٢٠مم ⇐ بعد ٥ أيّام) ويُنشئ له مهمّة وحدثًا في التقويم.', en: 'The system sets the next exam date from the follicle size (32 mm ⇒ tomorrow … under 20 mm ⇒ 5 days) and creates a task and a calendar event for it.' },
						status: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' },
					},
					{
						title: { ar: '٣ — حفّز الإباضة', en: '3 — Trigger ovulation' },
						detail: { ar: 'حين تنضج الحويصلة سجّل «تحفيز الإباضة» بتاريخه ووقته.', en: 'When the follicle is mature, record the ovulation trigger with its date and time.' },
						auto: { ar: 'يحسب النظام نافذة تأكيد الإباضة: من ٣٦ إلى ٤٨ ساعة بعد التحفيز، ويضعها مهمّةً في التقويم.', en: 'The system computes the confirmation window: 36 to 48 hours after the trigger, and schedules it as a task.' },
					},
					{
						title: { ar: '٤ — سجّل القفزة كتلقيح', en: '4 — Record the cover as an insemination' },
						detail: { ar: 'تسجيل التلقيح في النظام مرتبط دائمًا بدفعة في مخزون السائل المنوي — لأنّ لكلّ تلقيح مصدرًا موثَّقًا. لذا أنشئ للفحل دفعة من نوع Fresh تمثّل قفزاته، واستهلك منها جرعة لكلّ قفزة.', en: 'Recording an insemination is always tied to a semen inventory batch — every insemination has a documented source. So create a Fresh batch for the stallion representing his covers, and consume one dose per cover.' },
						auto: { ar: 'الحالة تصير «ملقحة»، وتُنشأ رسوم الإجراء إن كان له سعر في «إجراءات الإنتاج».', en: 'The case becomes Inseminated, and the procedure charge is created if it is priced in the reproduction catalogue.' },
						status: { ar: 'ملقحة', en: 'Inseminated' },
					},
					{
						title: { ar: '٥ — أكّد الإباضة', en: '5 — Confirm ovulation' },
						detail: { ar: 'داخل النافذة، سجّل «تأكيد الإباضة» بتاريخه ووقته الفعليّين. هذا التاريخ هو المرجع لكلّ ما بعده.', en: 'Inside the window, record the ovulation confirmation with its actual date and time. That date is the reference for everything after it.' },
						auto: { ar: 'يُحسب أوّل فحص حمل (+١٤ يومًا) وتاريخ الولادة المتوقّع (+٣٤٠ يومًا)، وتُنشأ لهما مهمّة وحدث تقويم.', en: 'The first pregnancy check (+14 days) and the expected foaling date (+340 days) are computed, with a task and calendar event for each.' },
					},
					{
						title: { ar: '٦ — افحص الحمل', en: '6 — Check the pregnancy' },
						detail: { ar: 'في الموعد المستحقّ سجّل «فحص حمل» ونتيجته. الفحص التوأميّ يُسجَّل هنا أيضًا.', en: 'On the due date record a pregnancy check and its result. A twin finding is recorded here too.' },
						auto: { ar: 'النتيجة الإيجابيّة تنقل الحالة إلى «حامل» وتفتح متابعةً بعد ٤٠ يومًا. والحمل التوأميّ يولّد تنبيهًا حَرِجًا.', en: 'A positive result moves the case to Pregnant and opens a re-check after 40 days. A twin pregnancy raises a critical notification.' },
						status: { ar: 'حامل أو غير حامل', en: 'Pregnant or Not pregnant' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'إنشاء دفعة تمثّل القفزات ممارسة تنظيميّة لا قاعدة يفرضها النظام؛ فائدتها أنّ عدد القفزات لكلّ فحل يصير قابلًا للعدّ والمراجعة بدل أن يبقى في الذاكرة.',
					en: 'Creating a batch to represent covers is an organisational practice, not a rule the system enforces; its benefit is that each stallion’s cover count becomes countable and auditable instead of living in someone’s memory.',
				},
			},
		],
	},

	{
		id: 'scenario-add-recipient',
		title: { ar: 'سيناريو ٤ — إضافة فرس حاضنة إلى السجلّ', en: 'Scenario 4 — Adding a recipient mare to the registry' },
		summary: { ar: 'الخطوة التي تسبق أيّ نقل أجنّة: من تكون الحاضنة، وكيف تُسنَد.', en: 'The step before any embryo transfer: who counts as a recipient, and how she is assigned.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'الفرس لا تصير حاضنة باشتقاق تلقائيّ ولا بعلامة أثناء تسجيل الخيل، بل بإسناد يدويّ في صفحة «الأفراس الحاضنة». والسبب أنّ هذا **دور موسميّ قابل للعكس** — تحضن هذا الموسم وقد تكون مانحة في القادم — بينما سجلّ الخيل هويّة دائمة.',
					en: 'A mare does not become a recipient by automatic derivation or by a flag when registering the horse, but by manual assignment in the Recipient mares screen. The reason: this is a **reversible seasonal role** — she may carry this season and donate the next — while the horse record is a permanent identity.',
				},
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح «الأفراس الحاضنة»', en: '1 — Open Recipient mares' },
						detail: { ar: 'من شريط المداخل أعلى صفحة عيادة الإنتاج.', en: 'From the entry row at the top of the reproduction page.' },
					},
					{
						title: { ar: '٢ — أضف الفرس', en: '2 — Add the mare' },
						detail: { ar: 'زرّ الإضافة، ثمّ اختر: **من خيل المركز** (تُربط بسجلّ الخيل) أو **حاضنة مستأجرة** (اسم وبلد ومالك بلا سجلّ خيل عندنا). الثانية مدعومة عمدًا: الحاضنة المستأجرة واقع، وإجبارها على سجلّ خيل كامل يُلوّث قائمة خيل المركز.', en: 'Press add, then choose: **an in-house horse** (linked to its horse record) or **a rented recipient** (name, country and owner with no horse record here). The second is supported deliberately: rented recipients are a fact of the work, and forcing a full horse record for one pollutes the centre’s horse list.' },
					},
					{
						title: { ar: '٣ — تأكّد من أثر الإسناد', en: '3 — Understand what the assignment changes' },
						detail: { ar: 'الفرس المسنَدة تظهر في قوائم **تزامن المستقبِلة** و**الطرف المستقبِل في النقل** وحدها، وتختفي من قوائم **التلقيح وغسل الأجنّة**. وتبقى فرسًا كاملة في كلّ ما عدا ذلك: الفحوصات والحمل والولادة والتطعيم والملكيّة والإحصاءات.', en: 'An assigned mare appears only in **recipient synchronisation** and as the **receiving side of a transfer**, and disappears from **insemination and flushing** lists. She remains a full mare in everything else: examinations, pregnancy, foaling, vaccination, ownership and statistics.' },
					},
					{
						title: { ar: '٤ — إخراجها من الخدمة عند اللزوم', en: '4 — Retire her when needed' },
						detail: { ar: 'زرّ الإخراج من الخدمة **ليس حذفًا**: الفرس تخرج من قوائم الاختيار ويبقى تاريخها كاملًا، ويمكن إعادتها في أيّ وقت.', en: 'Retiring is **not deleting**: she leaves the selection lists, her full history remains, and she can be restored at any time.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'إن لم تجد فرسًا في قائمة التلقيح، فالسبب غالبًا أنّها مسنَدة كحاضنة. أخرِجها من السجلّ إن كان الإسناد خطأً.',
					en: 'If a mare is missing from the insemination list, she is most likely assigned as a recipient. Retire her from the registry if that was a mistake.',
				},
			},
		],
	},

	{
		id: 'scenario-donor',
		title: { ar: 'سيناريو ٥ — نقل الأجنّة: الفرس المانحة', en: 'Scenario 5 — Embryo transfer: the donor mare' },
		summary: { ar: 'الفرس التي يُنسب إليها المولود. مسارها ينتهي عند الغسل لا عند الحمل.', en: 'The mare the foal is attributed to. Her path ends at the flush, not at a pregnancy.' },
		blocks: [
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'القاعدة التي يقوم عليها هذا المسار كلّه: الولادة تُسجَّل على الحاضنة، لكنّ أمّ المولود نَسَبيًّا هي المانحة. أيّ توثيق يأخذ الأمّ من الفرس التي ولدت يُنتج نسبًا خاطئًا في كلّ مولود نقل أجنّة — وخطأ لا يُكتشف إلّا بعد سنوات.',
					en: 'The rule this entire path rests on: the birth is recorded on the recipient, but the foal’s dam is the donor. Any documentation that takes the dam from the mare who gave birth produces a wrong pedigree for every embryo-transfer foal — an error discovered only years later.',
				},
			},
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'حالة مانحة', en: 'Donor case' }, sub: { ar: 'مفتوحة', en: 'Open' } },
					{ label: { ar: 'متابعة وتحفيز', en: 'Monitor & trigger' }, sub: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' } },
					{ label: { ar: 'تلقيح', en: 'Insemination' }, sub: { ar: 'ملقحة', en: 'Inseminated' } },
					{ label: { ar: 'تأكيد الإباضة', en: 'Confirm ovulation' }, sub: { ar: 'مرجع نافذة الغسل', en: 'flush window reference' } },
					{ label: { ar: 'غسل الأجنّة', en: 'Embryo flush' }, sub: { ar: 'تم غسل الأجنة', en: 'Flushed' } },
					{ label: { ar: 'النقل إلى حاضنة', en: 'Transfer to a recipient' }, sub: { ar: 'حالتها لا تتغيّر', en: 'her status is untouched' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح الحالة بنوع «مانحة أجنة»', en: '1 — Open the case as “Embryo transfer donor”' },
						detail: { ar: 'من صفحة عيادة الإنتاج. اختيار النوع الصحيح هنا هو ما يجعل بقيّة الشاشات تعرض لك المسار الصحيح.', en: 'From the reproduction page. Choosing the right type here is what makes the remaining screens offer you the right path.' },
						status: { ar: 'مفتوحة', en: 'Open' },
					},
					{
						title: { ar: '٢ — تابع الحويصلة بالسونار', en: '2 — Monitor the follicle by ultrasound' },
						detail: { ar: 'من داخل الحالة: أضف فحصًا من نوع «سونار» وسجّل حجم الحويصلة بالمليمتر وحالة الرحم.', en: 'From inside the case: add an “Ultrasound” examination and record the follicle size in millimetres and the uterine state.' },
						auto: { ar: 'يحدّد النظام موعد الفحص التالي من حجم الحويصلة (٣٢مم ⇐ غدًا … أقلّ من ٢٠مم ⇐ بعد ٥ أيّام) ويُنشئ له مهمّة وحدثًا في التقويم.', en: 'The system sets the next exam date from the follicle size (32 mm ⇒ tomorrow … under 20 mm ⇒ 5 days) and creates a task and a calendar event for it.' },
						status: { ar: 'بانتظار الإباضة', en: 'Waiting ovulation' },
					},
					{
						title: { ar: '٣ — حفّز الإباضة', en: '3 — Trigger ovulation' },
						detail: { ar: 'حين تنضج الحويصلة سجّل «تحفيز الإباضة» بتاريخه ووقته.', en: 'When the follicle is mature, record the ovulation trigger with its date and time.' },
						auto: { ar: 'يحسب النظام نافذة تأكيد الإباضة: من ٣٦ إلى ٤٨ ساعة بعد التحفيز.', en: 'The system computes the confirmation window: 36 to 48 hours after the trigger.' },
					},
					{
						title: { ar: '٤ — سجّل التلقيح', en: '4 — Record the insemination' },
						detail: { ar: 'اختر الفحل ودفعة السائل المنويّ من المخزون وعدد الجرعات. الدفعة إلزاميّة — فلكلّ تلقيح مصدر موثَّق، وتُخصم الجرعة في نفس اللحظة.', en: 'Choose the stallion, the semen batch from inventory, and the number of doses. The batch is mandatory — every insemination has a documented source, and the dose is deducted at that same moment.' },
						auto: { ar: 'الفحل المسجَّل هنا هو الذي سيُنسب إليه المولود لاحقًا — فالنظام يأخذ الأب من تلقيح المانحة، لا من مكان آخر.', en: 'The stallion recorded here is the one the foal will be attributed to — the system takes the sire from the donor’s insemination, nowhere else.' },
						status: { ar: 'ملقحة', en: 'Inseminated' },
					},
					{
						title: { ar: '٥ — أكّد الإباضة', en: '5 — Confirm ovulation' },
						detail: { ar: 'داخل النافذة، سجّل «تأكيد الإباضة» بتاريخه ووقته الفعليّين. تاريخ الإباضة المؤكَّد هو ما تُحسب منه نافذة الغسل، فسجّله بدقّة.', en: 'Inside the window, record the ovulation confirmation with its actual date and time. The confirmed ovulation date is what the flush window is computed from, so record it accurately.' },
					},
					{
						title: { ar: '٦ — اغسل الجنين', en: '6 — Flush the embryo' },
						detail: { ar: 'من صفحة «نقل الأجنّة» ← قسم الغسل: اختر حالة المانحة وسجّل تاريخ الغسل وعدد الأجنّة المستخلَصة.', en: 'From the embryo transfer page → flush section: pick the donor case and record the flush date and the number of embryos recovered.' },
						auto: { ar: 'يحسب النظام اليوم الذي وقع فيه الغسل بعد الإباضة ويصنّفه: داخل النافذة (٧–٨)، أو تحذير (من ٦٫٥)، أو خارج النافذة. التصنيف يظهر لك قبل الحفظ.', en: 'The system computes which day after ovulation the flush occurred and classifies it: within the window (7–8), a warning (from 6.5), or outside the window. The classification is shown before saving.' },
						status: { ar: 'تم غسل الأجنة', en: 'Flushed' },
					},
					{
						title: { ar: '٧ — بعد النقل: لا تلمس حالتها', en: '7 — After the transfer: leave her status alone' },
						detail: { ar: 'حين يُنقل الجنين إلى الحاضنة تبقى المانحة على «تم غسل الأجنة». هذه ليست حالة عالقة — هي سجلّها الصحيح: هي غُسلت، ولم يُنقل إليها شيء.', en: 'When the embryo is transferred into the recipient, the donor stays on “Flushed”. That is not a stuck status — it is her correct record: she was flushed, and nothing was transferred into her.' },
					},
				],
			},
		],
	},

	{
		id: 'scenario-recipient',
		title: { ar: 'سيناريو ٦ — نقل الأجنّة: الفرس الحاضنة', en: 'Scenario 6 — Embryo transfer: the recipient mare' },
		summary: { ar: 'من إسناد الفرس كحاضنة، إلى ربطها بالمانحة، إلى النقل والحمل والولادة.', en: 'From marking a mare as a recipient, to pairing her with a donor, to transfer, pregnancy and foaling.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'يبدأ هذا المسار بفرسٍ **موجودة في سجلّ الحاضنات** — إن لم تكن كذلك فأسنِدها أوّلًا من صفحة «الأفراس الحاضنة». والإسناد لا يغيّر شيئًا في الفرس إلّا قوائم الاختيار: تظهر للتزامن وللنقل، وتختفي من التلقيح وغسل الأجنّة، وتبقى فرسًا كاملة في الفحوصات والحمل والولادة والملكيّة.',
					en: 'This path begins with a mare **already in the recipient registry** — if she is not, assign her first from the Recipient mares screen. The assignment changes nothing about her except the selection lists: she appears for synchronisation and transfer, disappears from insemination and flushing, and remains a full mare for examinations, pregnancy, foaling and ownership.',
				},
			},
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'أسنِد الفرس كحاضنة', en: 'Assign as recipient' }, sub: { ar: 'الأفراس الحاضنة', en: 'Recipient mares' } },
					{ label: { ar: 'افتح حالة مستقبلة', en: 'Open a recipient case' }, sub: { ar: 'مفتوحة', en: 'Open' } },
					{ label: { ar: 'اربطها بالمانحة', en: 'Pair with the donor' }, sub: { ar: 'تزامن', en: 'synchronisation' } },
					{ label: { ar: 'انقل الجنين', en: 'Transfer the embryo' }, sub: { ar: 'تم النقل', en: 'Transferred' } },
					{ label: { ar: 'افحص الحمل', en: 'Pregnancy check' }, sub: { ar: 'حامل', en: 'Pregnant' } },
					{ label: { ar: 'الولادة', en: 'Foaling' }, sub: { ar: 'المولود يُنسب للمانحة', en: 'foal attributed to the donor' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح حالة بنوع «مستقبلة أجنة»', en: '1 — Open a case as “Embryo transfer recipient”' },
						detail: { ar: 'للفرس الحاضنة نفسها. هذه حالتها هي، بمتابعتها وفحوصاتها وولادتها.', en: 'For the recipient mare herself. This is her own case, with her monitoring, examinations and foaling.' },
						status: { ar: 'مفتوحة', en: 'Open' },
					},
					{
						title: { ar: '٢ — تابع إباضتها', en: '2 — Monitor her ovulation' },
						detail: { ar: 'من داخل الحالة: أضف فحوصات «سونار» تسجّل حجم الحويصلة وحالة الرحم، ثمّ حفّز الإباضة، ثمّ سجّل «تأكيد الإباضة» داخل نافذة الـ٣٦–٤٨ ساعة. لا تلقيح هنا — الحاضنة لا تُلقَّح. والغرض من كلّ هذا أن يكون تاريخ إباضتها معلومًا بدقّة، فالتزامن بين إباضتها وإباضة المانحة هو ما يُنجح النقل أو يُفشله.', en: 'From inside the case: add “Ultrasound” examinations recording follicle size and uterine state, then trigger ovulation, then record the ovulation confirmation inside the 36–48 hour window. No insemination here — a recipient is not inseminated. The purpose of all of it is to know her ovulation date precisely, since the synchronisation between her ovulation and the donor’s is what makes or breaks the transfer.' },
						status: { ar: 'بانتظار الإباضة ← تمّت الإباضة', en: 'Waiting ovulation → Ovulated' },
					},
					{
						title: { ar: '٣ — اربطها بالمانحة', en: '3 — Pair her with the donor' },
						detail: { ar: 'من «نقل الأجنّة» ← قسم التزامن: اختر المانحة ثمّ الحاضنة من قائمة الحاضنات غير المرتبطة.', en: 'From the embryo transfer page → synchronisation: pick the donor, then the recipient from the list of unpaired recipients.' },
						auto: { ar: 'يحسب النظام فارق الإباضتين ويصنّفه فورًا: مثاليّ (٠ إلى +٢) · مقبول (−١ إلى +٣) · حدّيّ · غير موصى به. والتحذير يظهر عند الربط لا عند النقل — حيث ما زال بالإمكان اختيار حاضنة أخرى.', en: 'The system computes the difference between the two ovulations and classifies it immediately: ideal (0 to +2) · acceptable (−1 to +3) · borderline · not recommended. The warning appears at pairing, not at transfer — while another recipient can still be chosen.' },
					},
					{
						title: { ar: '٤ — انقل الجنين', en: '4 — Transfer the embryo' },
						detail: { ar: 'من قسم النقل: اختر الغسلة والحاضنة المرتبطة بها وسجّل تاريخ النقل.', en: 'From the transfer section: pick the flush and its paired recipient, and record the transfer date.' },
						auto: { ar: 'تصير الحاضنة «تم النقل»، ويُستهلك الارتباط فلا تظهر مرشّحةً لنقل آخر. أمّا المانحة فتبقى «تم غسل الأجنة» — سجلّها لا يُمسّ.', en: 'The recipient becomes Transferred and the pairing is consumed so she no longer appears as a candidate for another transfer. The donor stays Flushed — her record is untouched.' },
						status: { ar: 'تم النقل', en: 'Transferred' },
					},
					{
						title: { ar: '٥ — افحص الحمل وتابعه', en: '5 — Check and follow the pregnancy' },
						detail: { ar: 'كأيّ حمل: فحص الحمل ثمّ المتابعة حتى الولادة. الحاضنة هنا فرس حامل كاملة الحقوق في المتابعة.', en: 'Like any pregnancy: a pregnancy check, then follow-up to foaling. The recipient here is a fully monitored pregnant mare.' },
						status: { ar: 'حامل', en: 'Pregnant' },
					},
					{
						title: { ar: '٦ — الولادة', en: '6 — Foaling' },
						detail: { ar: 'تُسجَّل الولادة على حالة الحاضنة — لأنّها هي التي ولدت. وسلسلة النسب تتكفّل بنسب المولود إلى المانحة.', en: 'The foaling is recorded on the recipient’s case — because she is the one who gave birth. The pedigree chain takes care of attributing the foal to the donor.' },
					},
				],
			},
		],
	},

	{
		id: 'scenario-followup',
		title: { ar: 'سيناريو ٧ — فرس وصلت حاملًا (متابعة حمل)', en: 'Scenario 7 — A mare that arrived pregnant (follow-up)' },
		summary: { ar: 'لا تلقيح ولا إباضة — متابعة من نقطة الوصول حتى الولادة.', en: 'No insemination, no ovulation — follow-up from arrival to foaling.' },
		blocks: [
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح الحالة بنوع «متابعة حمل»', en: '1 — Open the case as “Pregnancy follow-up”' },
						detail: { ar: 'هذا النوع لا يعرض عليك حالات ما قبل الحمل أصلًا — فلا «بانتظار الإباضة» ولا «ملقحة». وهذا مقصود: لم يحدث شيء من ذلك عندنا.', en: 'This type does not offer you any pre-pregnancy statuses at all — no “waiting ovulation”, no “inseminated”. That is deliberate: none of it happened here.' },
					},
					{
						title: { ar: '٢ — سجّل ما تعرفه عن الحمل', en: '2 — Record what is known about the pregnancy' },
						detail: { ar: 'أضف فحص حمل بنتيجته وتاريخه. إن كان تاريخ التلقيح أو الإباضة معلومًا من المصدر، أدخِله لتُحسب الولادة المتوقّعة عليه؛ وإلّا فالمتابعة تبدأ من الفحص.', en: 'Add a pregnancy check with its result and date. If the breeding or ovulation date is known from the source, enter it so the expected foaling is computed from it; otherwise follow-up starts from the check.' },
						status: { ar: 'حامل', en: 'Pregnant' },
					},
					{
						title: { ar: '٣ — تابع حتى الولادة', en: '3 — Follow through to foaling' },
						detail: { ar: 'الفحوصات الدوريّة والتطعيمات ومتابعة الولادة كلّها متاحة كأيّ حمل آخر.', en: 'Routine examinations, vaccinations and foaling monitoring are all available as in any other pregnancy.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'نسب المولود هنا لا يستطيع النظام اشتقاقه — فلا تلقيح مسجَّل عندنا ولا فحل معروف. أدخِل النسب يدويًّا وقت تسجيل المولود، مع ذكر مصدر المعلومة في الملاحظات.',
					en: 'The foal’s pedigree cannot be derived here — there is no insemination on record and no known stallion. Enter the pedigree manually when registering the foal, and note the source of the information.',
				},
			},
		],
	},

	{
		id: 'foaling',
		title: { ar: 'سيناريو ٨ — الولادة والمواليد وربطها بالنسب', en: 'Scenario 8 — Foaling, foals and linking them to the pedigree' },
		summary: { ar: 'من تسجيل الواقعة إلى مولود له سجلّ خيل بنسب مرتبط بالمفاتيح.', en: 'From recording the event to a foal with a horse record and a key-linked pedigree.' },
		blocks: [
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'اختر الحالة', en: 'Pick the case' }, sub: { ar: 'الولادات والمواليد', en: 'Foalings screen' } },
					{ label: { ar: 'سجّل الواقعة', en: 'Record the foaling' }, sub: { ar: 'وقت خروج المولود', en: 'delivery time' } },
					{ label: { ar: 'أضف المواليد', en: 'Add the foals' }, sub: { ar: 'واحد لكلّ جنين', en: 'one per foal' } },
					{ label: { ar: 'راجع سلسلة النسب', en: 'Review the chain' }, sub: { ar: 'الأب والأمّ', en: 'sire and dam' } },
					{ label: { ar: 'سجّله خيلًا', en: 'Register as a horse' }, sub: { ar: 'نسب مرتبط', en: 'linked pedigree' } },
				],
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح «الولادات والمواليد» واختر الحالة', en: '1 — Open Foalings and foals, and pick the case' },
						detail: { ar: 'من «الولادات والمواليد»: اختر الحالة، ثمّ زرّ «تسجيل واقعة الولادة». الإلزاميّ حقلٌ واحد: وقت خروج المولود — فمنه يُشتقّ تاريخ ميلاده عند تسجيله خيلًا. والباقي (نزول الماء، المشيمة، علامات ما قبل الولادة، النتيجة، الطارئ) يُملأ بقدر ما رُصد.', en: 'From the foalings screen: pick the case, then press “Record foaling”. One field is required: the delivery time — the foal’s date of birth is derived from it when the foal is registered as a horse. The rest (water breaking, placenta, pre-foaling signs, outcome, emergency) is filled in as far as it was observed.' },
					},
					{
						title: { ar: '٢ — أضف المولود (أو المولودين)', en: '2 — Add the foal (or foals)' },
						detail: { ar: 'لكلّ مولود: الجنس، والحالة (حيّ / ميت عند الولادة / نفق بعدها)، ووقت الولادة، واللون والعلامات. التوأم يُسجَّل مولودَين لا سجلًّا واحدًا.', en: 'For each foal: sex, status (alive / stillborn / died after), birth time, colour and markings. Twins are recorded as two foals, not one record.' },
					},
					{
						title: { ar: '٣ — راجع بطاقة سلسلة النسب', en: '3 — Review the pedigree chain card' },
						detail: { ar: 'تعرض البطاقة السلسلة كاملة: الفحل ← المانحة ← الغسل ← النقل ← الحاضنة ← الولادة ← المولود، وتقول صراحةً في حالة النقل إنّ الولادة على الحاضنة والأمّ نَسَبيًّا هي المانحة.', en: 'The card shows the full chain: stallion → donor → flush → transfer → recipient → foaling → foal, and states explicitly in a transfer case that the birth is on the recipient while the dam is the donor.' },
					},
					{
						title: { ar: '٤ — سجّل المولود خيلًا', en: '4 — Register the foal as a horse' },
						detail: { ar: 'زرّ التسجيل يُنشئ للمولود سجلًّا في «قائمة الخيل» بنسب مرتبط بالمفاتيح: الأمّ من المانحة (لا من الحاضنة)، والأب من تلقيح المانحة، وتاريخ الميلاد من وقت الولادة.', en: 'The register button creates a record for the foal in the horse list with a key-linked pedigree: the dam from the donor (not the recipient), the sire from the donor’s insemination, and the date of birth from the foaling time.' },
						auto: { ar: 'تُكتب الأسماء النصّيّة أيضًا إلى جانب الروابط، فتبقى التقارير القديمة عاملة. والمالك المقترَح هو مالك المانحة — راجِعه قبل التأكيد، فعقود الحضانة تختلف.', en: 'Text names are written alongside the links, so older reports keep working. The suggested owner is the donor’s owner — review it before confirming, since recipient contracts differ.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'warn',
				text: {
					ar: 'الغاية من هذا كلّه أن يحلّ التوثيق المرتبط محلّ الكتابة اليدويّة: اسم أمّ مكتوب بحرف خاطئ يُنشئ سلفًا مختلفًا بصمت، ولا يُكتشف إلّا حين يُطلب إثبات النسب.',
					en: 'The point of all this is that linked documentation replaces typing: a dam’s name with one wrong letter silently creates a different ancestor, and it is only discovered when the pedigree has to be proven.',
				},
			},
		],
	},

	{
		id: 'scenario-tasks',
		title: { ar: 'سيناريو ٩ — يوم الطبيب: المهامّ المستحقّة', en: 'Scenario 9 — The vet’s day: due tasks' },
		summary: { ar: 'من أين تبدأ صباحك، وكيف تُغلق ما عليك.', en: 'Where your morning starts, and how you close what is on you.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'التقويم يعرض الموسم كلّه، وتبويب «المهامّ» نافذة عمل: **ما يستحقّ خلال ٤٨ ساعة وما فات موعده** — لا أرشيف. والمهامّ تُولَد وحدها من البروتوكول: تسجّل تحفيز إباضة فتُولد مهمّة «تأكيد الإباضة»، وتؤكّد الإباضة فتُولد مهمّة «أوّل فحص حمل».',
					en: 'The calendar shows the whole season; the Tasks tab is a working window: **what is due within 48 hours and anything overdue** — not an archive. Tasks are generated by the protocol itself: record an ovulation trigger and a “confirm ovulation” task is created; confirm the ovulation and a “first pregnancy check” task appears.',
				},
			},
			{
				kind: 'steps',
				items: [
					{
						title: { ar: '١ — افتح تبويب «المهامّ»', en: '1 — Open the Tasks tab' },
						detail: { ar: 'ما تراه هو ما يستحقّ الآن أو فات. المتأخّر يُعلَّم «فات موعدها» بلون التحذير.', en: 'What you see is what is due now or overdue. Late items are marked “overdue” in the warning colour.' },
					},
					{
						title: { ar: '٢ — افتح «إجراءات المهمّة»', en: '2 — Open Task actions' },
						detail: { ar: 'تظهر بطاقة المهمّة (العنوان والموعد والفرس) ثمّ خياراها: **أنجزت** أو **إلغاء المهمّة**.', en: 'The task card appears (title, due date, mare) with its two options: **mark done** or **cancel task**.' },
					},
					{
						title: { ar: '٣ — إن أنجزتها', en: '3 — If you completed it' },
						detail: { ar: 'اكتب النتيجة (اختياريّة) واضغط «أنجزت». أو اضغط **«تسجيل الإجراء في الحالة»** فيفتح لك ملفّ الحالة ونموذج الإجراء مباشرةً — وهناك توثَّق النتيجة السريريّة حيث تُقرأ بعد سنة.', en: 'Write the result (optional) and press Mark done. Or press **Record the action in the case**, which opens the case file and its action form — that is where the clinical result belongs, because that is where it will be read a year later.' },
					},
					{
						title: { ar: '٤ — إن لم تعد هناك حاجة', en: '4 — If it is no longer needed' },
						detail: { ar: 'اختر «إلغاء المهمّة» **واكتب السبب — وهو إلزاميّ**. مهمّة ملغاة بلا سبب لا تُقرأ بعد ستّة أشهر.', en: 'Choose Cancel task **and write the reason — it is mandatory**. A cancelled task with no reason is unreadable six months later.' },
					},
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'وقت الإغلاق يكتبه الخادم لا جهازك: هو شهادة على متى أُغلقت المهمّة فعلًا. ولا إسناد لطبيب بعينه — المناوب هو من ينفّذ.',
					en: 'The closing time is written by the server, not your device: it is testimony about when the task was actually closed. And there is no per-vet assignment — whoever is on duty does the work.',
				},
			},
		],
	},
];

// helpAdmin.ts — أقسام: البيطار · المخزون · المحاسبة · الإعدادات والصلاحيات · أسئلة شائعة · مسرد.

const ADMIN_SECTIONS = [
	{
		id: 'farrier',
		title: { ar: 'البيطار', en: 'Farrier' },
		summary: { ar: 'سجلّات الحدوة وموادّها وإجراءاتها.', en: 'Shoeing records, materials and procedures.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'وحدة مستقلّة عن العيادة البيطريّة بكتالوجها الخاصّ: «إجراءات البيطار» بأسعارها و«مواد البيطار» بمخزونها. سجلّ البيطار يُنشأ للخيل كسجلّ العيادة تمامًا: إجراءات + موادّ ⇒ إجماليّ ⇒ محاسبة.',
					en: 'A module separate from the veterinary clinic with its own catalogue: farrier procedures with their prices and farrier materials with their stock. A farrier record is created for a horse exactly like a clinic record: procedures + materials ⇒ total ⇒ accounting.',
				},
			},
			{
				kind: 'list',
				items: [
					{ ar: '«إضافة سجل بيطار» لإنشاء السجلّ، و«سجلات البيطار» لعرضها، و«تفاصيل سجل البيطار» لفتح واحد.', en: 'Add farrier record to create one, farrier records to list them, farrier details to open one.' },
					{ ar: 'الموادّ المستهلَكة تُخصم من مخزون موادّ البيطار.', en: 'Consumed materials are deducted from farrier material stock.' },
					{ ar: 'نفس قاعدة الفوترة: خيل يملكه الإسطبل لا يُفوتَر.', en: 'The same billing rule: a horse the stable owns is not billed.' },
				],
			},
		],
	},

	{
		id: 'inventory',
		title: { ar: 'المخزون — الأدوية والسائل المنويّ', en: 'Inventory — medications and semen' },
		summary: { ar: 'مخزونان مختلفان بطبيعتهما، وكلاهما يُخصم آليًّا عند الاستخدام.', en: 'Two different kinds of stock, both deducted automatically on use.' },
		blocks: [
			{
				kind: 'table',
				head: [
					{ ar: 'المخزون', en: 'Stock' },
					{ ar: 'وحدة الحساب', en: 'Unit' },
					{ ar: 'متى يُخصم', en: 'Deducted when' },
				],
				rows: [
					[
						{ ar: 'أدوية العيادة', en: 'Clinic medications' },
						{ ar: 'وحدات الدواء (تُحسب من التكرار × المدّة)', en: 'medication units (frequency × duration)' },
						{ ar: 'عند حفظ سجلّ العيادة', en: 'when the clinic record is saved' },
					],
					[
						{ ar: 'مواد البيطار', en: 'Farrier materials' },
						{ ar: 'الكمّيّة المستهلَكة', en: 'quantity consumed' },
						{ ar: 'عند حفظ سجلّ البيطار', en: 'when the farrier record is saved' },
					],
					[
						{ ar: 'السائل المنويّ', en: 'Semen' },
						{ ar: 'جرعات داخل دفعة (Fresh · Chilled · Frozen)', en: 'doses within a batch (Fresh · Chilled · Frozen)' },
						{ ar: 'عند تسجيل التلقيح — ولا يُسجَّل تلقيح بلا رصيد', en: 'when an insemination is recorded — and none is recorded without stock' },
					],
				],
			},
			{
				kind: 'note',
				tone: 'info',
				text: {
					ar: 'مخزون السائل المنويّ يميّز بين المستهلَك والمحجوز: الجرعة المحجوزة لخطّة تلقيح ليست متاحة لغيرها. راجع الرصيد قبل الموسم لا أثناءه.',
					en: 'Semen inventory separates used from reserved doses: a dose reserved for a breeding plan is not available to anything else. Review the balance before the season, not during it.',
				},
			},
		],
	},

	{
		id: 'accounting',
		title: { ar: 'المحاسبة — كيف تصير الخدمة رقمًا', en: 'Accounting — how a service becomes a figure' },
		summary: { ar: 'من الرسم المُنشأ آليًّا إلى الفاتورة والتقرير.', en: 'From the automatically created charge to the invoice and the report.' },
		blocks: [
			{
				kind: 'flow',
				nodes: [
					{ label: { ar: 'خدمة مُسجَّلة', en: 'Recorded service' }, sub: { ar: 'عيادة · إنتاج · بيطار · سكن', en: 'clinic · repro · farrier · housing' } },
					{ label: { ar: 'رسم', en: 'Charge' }, sub: { ar: 'بسعر الكتالوج', en: 'at catalogue price' } },
					{ label: { ar: 'مراجعة المحاسب', en: 'Accountant review' }, sub: { ar: 'تدقيق ما قبل الفوترة', en: 'pre-invoice check' } },
					{ label: { ar: 'الملخّص والدفتر', en: 'Summary & ledger' }, sub: { ar: 'حسب المالك والفترة', en: 'by owner and period' } },
				],
			},
			{
				kind: 'list',
				items: [
					{ ar: 'الرسم يُنشأ آليًّا للإجراء الذي له سعر في كتالوجه، بحالة «معلَّق» حتى تُراجعه المحاسبة.', en: 'A charge is created automatically for any procedure priced in its catalogue, as Pending until accounting reviews it.' },
					{ ar: 'خيل يملكه الإسطبل نفسه لا يُنشأ له رسم — الخدمة تُسجَّل ولا تُفوتَر.', en: 'No charge is created for a horse the stable itself owns — the service is recorded but not invoiced.' },
					{ ar: '«دفتر خدمات الخيل» يعرض ما على خيل واحد، و«الملخص المالي» يجمع حسب المالك والفترة.', en: 'The horse services ledger shows one horse’s items; the financial summary aggregates by owner and period.' },
					{ ar: 'نقل الملكيّة يُصدِر كشوفًا وفواتير عمّا قبل النقل — لأنّ المالك مُلتقَط وقت العمليّة لا وقت التقرير.', en: 'An ownership transfer exports statements and invoices for the period before it — because the owner is captured at operation time, not report time.' },
				],
			},
		],
	},

	{
		id: 'admin',
		title: { ar: 'الإعدادات والصلاحيات والنسخ الاحتياطيّ', en: 'Settings, permissions and backups' },
		summary: { ar: 'ما يضبطه المسؤول، وأثره على ما يراه الجميع.', en: 'What the administrator configures, and how it changes what everyone sees.' },
		blocks: [
			{
				kind: 'table',
				head: [
					{ ar: 'الشاشة', en: 'Screen' },
					{ ar: 'ما تضبطه', en: 'What it configures' },
				],
				rows: [
					[{ ar: 'الإعدادات', en: 'Settings' }, { ar: 'مدخل مصنَّف لكلّ إعدادات النظام — ومنها العيادة البيطريّة وعيادة الإنتاج كلٌّ في تصنيفه.', en: 'A categorised entry point to every system setting — the veterinary clinic and the reproduction clinic each in its own category.' }],
					[{ ar: 'الإعدادات العامة', en: 'System settings' }, { ar: 'بيانات المركز ومالك الإسطبل — وهو ما يحدّد أيّ خيل تُفوتَر وأيّها لا.', en: 'Centre data and the stable owner — which decides which horses are billed and which are not.' }],
					[{ ar: 'مركز الصلاحيات والقائمة', en: 'Access control' }, { ar: 'من يرى أيّ صفحة. الصفحة الجديدة تحتاج «مزامنة الصفحات» ثمّ منح الصلاحية.', en: 'Who sees which page. A new page needs a page sync, then a permission grant.' }],
					[{ ar: 'إدارة الأسعار', en: 'Pricing' }, { ar: 'أسعار الخدمات التي تعتمد عليها الرسوم.', en: 'The service prices that charges rely on.' }],
					[{ ar: 'النسخ الاحتياطي', en: 'Backups' }, { ar: 'أخذ النسخ ومتابعتها.', en: 'Taking and monitoring backups.' }],
					[{ ar: 'تقرير التدقيق', en: 'Audit report' }, { ar: 'من فعل ماذا ومتى — مرجع أيّ خلاف على بيانات.', en: 'Who did what and when — the reference for any dispute over data.' }],
					[{ ar: 'صحة النظام', en: 'System health' }, { ar: 'حالة الخادم والقاعدة والمهامّ الخلفيّة.', en: 'Server, database and background job status.' }],
				],
			},
		],
	},

	{
		id: 'faq',
		title: { ar: 'مواقف شائعة وحلولها', en: 'Common situations and what to do' },
		summary: { ar: 'ما يوقف المستخدمين فعلًا، وسببه.', en: 'What actually stops users, and why.' },
		blocks: [
			{
				kind: 'table',
				head: [
					{ ar: 'الموقف', en: 'Situation' },
					{ ar: 'السبب وما تفعله', en: 'Cause and what to do' },
				],
				rows: [
					[
						{ ar: 'لا أجد الفرس في قائمة التلقيح', en: 'The mare is missing from the insemination list' },
						{ ar: 'غالبًا لأنّها مسنَدة كحاضنة: الحاضنات لا تظهر في التلقيح ولا في غسل الأجنّة. أخرِجها من سجلّ الحاضنات إن كان الإسناد خطأً.', en: 'Usually because she is assigned as a recipient: recipients do not appear for insemination or flushing. Retire her from the recipient registry if the assignment was wrong.' },
					],
					[
						{ ar: 'لا أجد الحاضنة في قائمة النقل', en: 'The recipient is missing from the transfer list' },
						{ ar: 'إمّا أنّها غير مرتبطة بهذه المانحة (اربطها أوّلًا في قسم التزامن)، وإمّا أنّ جنينًا نُقل إليها فعلًا.', en: 'Either she is not paired with this donor (pair her first in the synchronisation section), or an embryo has already been transferred into her.' },
					],
					[
						{ ar: 'لا أجد حالة «حامل» في القائمة', en: '“Pregnant” is missing from the status list' },
						{ ar: 'نوع الحالة «مانحة أجنة»: المانحة لا تحمل — جنينها خرج منها. راجع نوع الحالة.', en: 'The case type is “donor”: a donor does not carry — her embryo left her. Check the case type.' },
					],
					[
						{ ar: 'الحالة تقول «ملقحة» ولم نلقّح', en: 'The status says Inseminated but nothing was inseminated' },
						{ ar: 'أُصلح هذا: تأكيد الإباضة صار ينقلها إلى «تمّت الإباضة» ما لم يكن هناك تلقيح مسجَّل فعلًا.', en: 'This was fixed: confirming ovulation now moves the case to “Ovulated” unless an insemination is actually on record.' },
					],
					[
						{ ar: 'لا يمكن حفظ التلقيح', en: 'The insemination will not save' },
						{ ar: 'رصيد الجرعات في الدفعة لا يكفي. راجع «مخزون السائل المنوي» — النظام لا يسجّل تلقيحًا بلا مصدر.', en: 'The batch does not have enough doses. Check semen inventory — the system will not record an insemination without a source.' },
					],
					[
						{ ar: 'الخدمة مسجَّلة ولا تظهر في المحاسبة', en: 'The service is recorded but absent from accounting' },
						{ ar: 'إمّا أنّ سجلّ العيادة لم يُعتمد بعد، وإمّا أنّ الخيل يملكه الإسطبل نفسه فلا يُفوتَر، وإمّا أنّ الإجراء بلا سعر في كتالوجه.', en: 'Either the clinic record is not approved yet, or the horse is owned by the stable and is therefore not billed, or the procedure has no price in its catalogue.' },
					],
					[
						{ ar: 'صفحة «لا صلاحية»', en: 'The “no access” page' },
						{ ar: 'الصفحة موجودة وغير ممنوحة لحسابك. اطلبها من مدير النظام.', en: 'The page exists but is not granted to your account. Request it from your administrator.' },
					],
				],
			},
		],
	},

	{
		id: 'glossary',
		title: { ar: 'مسرد المصطلحات', en: 'Glossary' },
		summary: { ar: 'المصطلحات التي تتكرّر في الشاشات، بلغة مفهومة.', en: 'The terms that recur across the screens, in plain language.' },
		blocks: [
			{
				kind: 'table',
				head: [
					{ ar: 'المصطلح', en: 'Term' },
					{ ar: 'المعنى', en: 'Meaning' },
				],
				rows: [
					[{ ar: 'الحالة (Case)', en: 'Case' }, { ar: 'ملفّ موسم واحد لفرس واحدة بغرض واحد، تُسجَّل داخله كلّ الأحداث.', en: 'One season file for one mare with one purpose; all events are recorded inside it.' }],
					[{ ar: 'الحويصلة', en: 'Follicle' }, { ar: 'الكيس الذي تنضج فيه البويضة في المبيض؛ حجمه بالمليمتر يحدّد موعد الفحص التالي.', en: 'The sac in which the egg matures in the ovary; its size in millimetres sets the next exam date.' }],
					[{ ar: 'الإباضة', en: 'Ovulation' }, { ar: 'خروج البويضة. تاريخها المؤكَّد هو المرجع لحساب فحص الحمل والولادة ونافذة الغسل.', en: 'Release of the egg. Its confirmed date is the reference for the pregnancy check, the foaling date and the flush window.' }],
					[{ ar: 'تحفيز الإباضة', en: 'Ovulation trigger' }, { ar: 'دواء يُعطى لضبط توقيت الإباضة؛ يفتح نافذة تأكيد من ٣٦ إلى ٤٨ ساعة.', en: 'A drug given to time ovulation; it opens a confirmation window of 36 to 48 hours.' }],
					[{ ar: 'غسل الأجنّة', en: 'Embryo flush' }, { ar: 'استخلاص الجنين من رحم المانحة في اليوم ٧–٨ بعد إباضتها.', en: 'Recovering the embryo from the donor’s uterus on day 7–8 after her ovulation.' }],
					[{ ar: 'المانحة', en: 'Donor' }, { ar: 'الفرس التي لُقّحت وغُسل جنينها — وهي أمّ المولود نَسَبيًّا.', en: 'The mare who was inseminated and whose embryo was flushed — the foal’s dam by pedigree.' }],
					[{ ar: 'الحاضنة (المستقبلة)', en: 'Recipient' }, { ar: 'الفرس التي يُنقل إليها الجنين فتحمله وتلده، ولا تُنسب إليها الأمومة.', en: 'The mare the embryo is transferred into, who carries and delivers it without being the dam.' }],
					[{ ar: 'التزامن', en: 'Synchronisation' }, { ar: 'تقارب إباضة الحاضنة من إباضة المانحة؛ الفارق المثاليّ ٠ إلى +٢ يوم.', en: 'How close the recipient’s ovulation is to the donor’s; the ideal difference is 0 to +2 days.' }],
					[{ ar: 'الارتباط', en: 'Pairing' }, { ar: 'ربط موثَّق بين حالة مانحة وحالة حاضنة قبل النقل؛ يمنع ازدواج الحجز ويُثبت السلسلة.', en: 'A documented link between a donor case and a recipient case before transfer; it prevents double booking and anchors the chain.' }],
					[{ ar: 'سلسلة النسب', en: 'Pedigree chain' }, { ar: 'الفحل ← المانحة ← الغسل ← النقل ← الحاضنة ← الولادة ← المولود، مرتبطة بالسجلّات لا مكتوبة يدويًّا.', en: 'Stallion → donor → flush → transfer → recipient → foaling → foal, linked to records rather than typed by hand.' }],
					[{ ar: 'الحذف الليّن', en: 'Soft delete' }, { ar: 'إخفاء السجلّ من القوائم مع بقائه في القاعدة للمراجعة.', en: 'Hiding a record from the lists while it remains in the database for review.' }],
				],
			},
		],
	},
];

// helpContent.ts — نصّ صفحة المساعدة (المصدر الوحيد للمسارين).
//
// كلّ رقم وكلّ اسم شاشة أدناه مقروء من الكود لا من الذاكرة: القيَم الزمنيّة من
// `utils/reproductionDateCalculator.js`، وأسماء الصفحات ومساراتها من
// `config/accessControlPageRegistry.js`، وقاعدة الفوترة من `createOperationalCharge`.
// نسخة المسار الآخر (`frontend/src/pages/help/helpContent.js`) مولَّدة من هذا الملفّ
// حرفيًّا بـ`scripts/sync_help_content.js` — التعديل هنا ثمّ إعادة التوليد، لا العكس.

export const HELP_INTRO = {
	ar: 'هذا الدليل يشرح النظام كما يعمل فعلًا: ماذا تفتح، وماذا تُدخل، وماذا يفعله النظام وحده بعد كلّ خطوة. الأقسام مرتّبة من العامّ إلى التفصيل، وقسم «سيناريوهات التلقيح والحمل» مكتوب لغير المختصّ: خطوات مرقّمة بلغة واضحة.',
	en: 'This guide describes the system as it actually behaves: what you open, what you enter, and what the system does on its own after each step. Sections run from general to detailed, and the insemination & pregnancy scenarios are written for non-specialists: numbered steps in plain language.',
};

const CORE_SECTIONS = [
	{
		id: 'overview',
		title: { ar: 'نظرة عامّة على النظام', en: 'System overview' },
		summary: { ar: 'ما الذي يديره النظام، وكيف ترتبط وحداته ببعضها.', en: 'What the system manages and how its modules connect.' },
		blocks: [
			{
				kind: 'p',
				text: {
					ar: 'Smart Stable نظام لإدارة مركز خيل. في قلبه سجلّ الخيل والمُلّاك، وحوله وحدات تشغيليّة تسجّل ما يجري للخيل يومًا بيوم (العيادة البيطريّة، عيادة الإنتاج، البيطار، السكن، المخزون)، ووحدات إداريّة تُحوّل ذلك إلى أرقام وتقارير (المحاسبة، الصلاحيات، التدقيق).',
					en: 'Smart Stable manages an equine centre. At its core is the horse and owner registry; around it, operational modules record what happens day by day (veterinary clinic, reproduction clinic, farrier, accommodation, inventory), and administrative modules turn that into figures and reports (accounting, permissions, audit).',
				},
			},
			{ kind: 'sub', text: { ar: 'ثلاث قواعد تسري على كلّ شيء', en: 'Three rules that apply everywhere' } },
			{
				kind: 'list',
				items: [
					{
						ar: 'كلّ عمل يبدأ من خيل مسجَّل. لا يُفتح سجلّ عيادة ولا حالة إنتاج لخيل غير موجود في «قائمة الخيل». إن لم تجد الخيل، سجّله أوّلًا.',
						en: 'Everything starts from a registered horse. No clinic record or reproduction case can be opened for a horse missing from the horse list. If the horse is not there, register it first.',
					},
					{
						ar: 'ما تراه يعتمد على صلاحيّتك. غياب صفحة من القائمة يعني أنّها غير ممنوحة لك، لا أنّها غير موجودة.',
						en: 'What you see depends on your permissions. A page missing from the menu means it is not granted to you, not that it does not exist.',
					},
					{
						ar: 'كلّ عمليّة تُسجَّل باسم منفّذها ووقتها. والحذف في أغلب الشاشات «حذف ليّن»: السجلّ يختفي من القوائم ولا يُمحى من القاعدة.',
						en: 'Every action records who did it and when. Deletion in most screens is a soft delete: the record leaves the lists but is not erased.',
					},
				],
			},
			{ kind: 'sub', text: { ar: 'خريطة الوحدات', en: 'Module map' } },
			{
				kind: 'table',
				head: [
					{ ar: 'الوحدة', en: 'Module' },
					{ ar: 'ما تفعله', en: 'What it does' },
					{ ar: 'أهمّ شاشاتها', en: 'Main screens' },
				],
				rows: [
					[
						{ ar: 'الخيل والمُلّاك', en: 'Horses & owners' },
						{ ar: 'السجلّ الأساسيّ الذي تعتمد عليه كلّ الوحدات', en: 'The base registry every module depends on' },
						{ ar: 'قائمة الخيل · تسجيل خيل · تفاصيل الخيل · قائمة الملّاك · شجرة النسب', en: 'Horse list · Register horse · Horse details · Owners · Pedigree tree' },
					],
					[
						{ ar: 'العيادة البيطريّة', en: 'Veterinary clinic' },
						{ ar: 'الكشف والعلاج وصرف الأدوية والفحوصات الدوريّة', en: 'Examinations, treatment, medication dispensing, routine checkups' },
						{ ar: 'نموذج سجل العيادة · سجلات العيادة · اعتمادات العيادة · الفحوصات البيطرية', en: 'Clinic form · Records · Approvals · Checkups' },
					],
					[
						{ ar: 'عيادة الإنتاج', en: 'Reproduction clinic' },
						{ ar: 'مواسم التلقيح والحمل والولادة ونقل الأجنّة وتوثيق النسب', en: 'Breeding seasons, pregnancy, foaling, embryo transfer, pedigree documentation' },
						{ ar: 'عيادة الإنتاج · نقل الأجنّة · الأفراس الحاضنة · الولادات والمواليد · بيانات الفحل', en: 'Reproduction · Embryo transfer · Recipient mares · Foalings · Stallions' },
					],
					[
						{ ar: 'البيطار', en: 'Farrier' },
						{ ar: 'سجلّات الحدوة وموادّها وإجراءاتها', en: 'Shoeing records, materials and procedures' },
						{ ar: 'سجلات البيطار · إجراءات البيطار · مواد البيطار', en: 'Farrier records · Procedures · Materials' },
					],
					[
						{ ar: 'المخزون', en: 'Inventory' },
						{ ar: 'أدوية العيادة وموادّها، ومخزون السائل المنويّ بجرعاته', en: 'Clinic medications and materials, and semen stock by dose' },
						{ ar: 'المخزون · أدوية العيادة · مخزون السائل المنوي', en: 'Inventory · Medications · Semen inventory' },
					],
					[
						{ ar: 'السكن', en: 'Accommodation' },
						{ ar: 'الإسطبلات والغرف وتسكين الخيل', en: 'Stables, rooms and horse placement' },
						{ ar: 'السكن · الغرف المتاحة · قائمة الإسطبلات · تقرير التسكين', en: 'Accommodation · Available rooms · Stables · Accommodation report' },
					],
					[
						{ ar: 'المحاسبة', en: 'Accounting' },
						{ ar: 'تحويل الخدمات المسجَّلة إلى رسوم وفواتير وتقارير', en: 'Turning recorded services into charges, invoices and reports' },
						{ ar: 'مراجعة المحاسب · الملخص المالي · دفتر خدمات الخيل · العقود', en: 'Accountant review · Financial summary · Horse ledger · Contracts' },
					],
					[
						{ ar: 'الإدارة', en: 'Administration' },
						{ ar: 'المستخدمون والصلاحيات والتنبيهات والنسخ الاحتياطيّ وصحّة النظام', en: 'Users, permissions, notifications, backups and system health' },
						{ ar: 'مركز الصلاحيات · قائمة المستخدمين · الإعدادات · النسخ الاحتياطي · تقرير التدقيق', en: 'Access control · Users · Settings · Backups · Audit report' },
					],
				],
			},
		],
	},
];

export const HELP_SECTIONS = [...CORE_SECTIONS, ...MODULE_SECTIONS, ...SCENARIO_SECTIONS, ...ADMIN_SECTIONS];
